module.exports = __webpack_public_path__ + "img/learn-4-on.56a89b79.png";